import React, { useEffect, useReducer} from 'react';
import {BrowserRouter,Routes, Route,Switch, useLocation} from 'react-router-dom'
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';
import $ from 'jquery'
import HomePage from '../components/HomePage';
import Homes from '../components/Homes';
import Apartments  from '../components/Apartments';
import About  from '../components/About';
import Oakgrandeurii from '../components/OakgrandeurII';
import Blog from '../components/Blog';
import Blogpost1 from '../components/Blogpost1';
import Blogpost2 from '../components/Blogpost2';
import Signup from '../components/Signup';
import Signin from '../components/Signin';
import RecoverPassword from '../components/RecoverPassword';
import CreateNewPassword from '../components/CreateNewPassword';
import Home from '../components/Home';
import BookAnApartment from '../components/BookAnApartment';
import Verify from '../components/Verify';
import HttpsRedirect from 'react-https-redirect';


const AppRouter = () => {
  return (
    <HttpsRedirect>
  <BrowserRouter>
  <div>
    <Route render={({location}) => (
    <TransitionGroup>
    <CSSTransition
      key={location.key}
      timeout={450}
      classNames="fade"
    >
  <Switch  location={location}>
  <Route path="/" component={HomePage} exact={true} />
  <Route path="/homes" component={Homes}  exact={true}/>
  <Route path="/apartments" component={Apartments}  exact={true}/>
  <Route path="/about" component={About}  exact={true}/>
  <Route path="/oakgrandeurii" component={Oakgrandeurii}  exact={true}/>
  <Route path="/blog" component={Blog}  exact={true}/>
  <Route path="/signup" component={Signup}  exact={true}/>
  <Route path="/verify" component={Verify}  exact={true}/>
  <Route path="/signin" component={Signin}  exact={true}/>
  <Route path="/recoverpassword" component={RecoverPassword}  exact={true}/>
  <Route path="/createpassword" component={CreateNewPassword}  exact={true}/>
  <Route path="/home" component={Home}  exact={true}/>
  <Route path="/bookanapartment" component={BookAnApartment}  exact={true}/>
  <Route path="/whyandwhenyoushouldinvestinrealestateinnigeria" component={Blogpost1}  exact={true}/>
  <Route path="/anearlychristmasgiftforyou" component={Blogpost2}  exact={true}/>


     </Switch>
     </CSSTransition>
  </TransitionGroup>
  )} />

{/* Without Transition */}
{/* <Route path="/explore" component={explorePage  } /> */}

      </div>
</BrowserRouter>
</HttpsRedirect>
)};
export default AppRouter;
